module.exports = __webpack_public_path__ + "assets/media/day19.1ea73edf.mp3";